//================================================================
//  Page: Enhancement
//================================================================

//  Purpose: Form for Enhancements

//================================================================

//Libraries
import React from 'react';

//Contexts

//Components

//Functions

//Images

//CSS

export default function Enhancement({
    task
}) {

    //------------------------------------------------------
    //  HTML
    //------------------------------------------------------

    return (
        <div className='h-full flex flex-col gap-2'>

            {/* ============================ */}
            {/*          Questions           */}
            {/* ============================ */}

            <form className='flex flex-col gap-4'>

                {/*==================1. What is the name of the initiative / request? *=================*/}
                <div className='Form-Row w-full'>
                    <label className='font-medium'> 1. What is the name of the initiative / request? <span className='text-[#C4314B]'>*</span> </label>
                    <input
                        disabled
                        className='Input-Field-Text  md:w-[450px]'
                        value={task?.initiativename}
                        type='text'
                    ></input>
                </div>

                {/*==================2. Which application does this relate to? *=================*/}
                <div className='Form-Row w-full'>
                    <label className='font-medium'> 2. Which application does this relate to? <span className='text-[#C4314B]'>*</span> </label>
                    <input
                        disabled
                        className='Input-Field-Text  md:w-[450px]'
                        value={task?.applicationname}
                        placeholder='Leave blank if unknown or not applicable'
                    ></input>
                </div>

                {/*==================3. What is the problem you are trying to solve? *=================*/}
                <div className='Form-Row w-full'>
                    <label className='font-medium'> 3. What is the problem you are trying to solve? <span className='text-[#C4314B]'>*</span> </label>
                    <textarea
                        disabled
                        className='Input-Field-TextArea'
                        value={task?.problemstatement}
                    ></textarea>
                </div>

                {/*==================4. What is the outcome you are looking for? *=================*/}
                <div className='Form-Row w-full'>
                    <label className='font-medium'> 4. What is the outcome you are looking for? <span className='text-[#C4314B]'>*</span> </label>
                    <textarea
                        disabled
                        className='Input-Field-TextArea'
                        value={task?.expectedoutcome}
                        type='text'
                    ></textarea>
                </div>

                {/*==================5. What would be the impact if this didn't go ahead? *=================*/}
                <div className='Form-Row w-full'>
                    <label className='font-medium'> 5. What would be the impact if this didn't go ahead? <span className='text-[#C4314B]'>*</span> </label>
                    <textarea
                        disabled
                        className='Input-Field-TextArea'
                        value={task?.businessimpact}
                        type='text'
                    ></textarea>
                </div>

                {/*==================6. Which business unit is driving this initiative? *=================*/}
                <div className='Form-Row w-full'>
                    <label className='font-medium'> 6. Which business unit is driving this initiative? <span className='text-[#C4314B]'>*</span> </label>
                    <select disabled className='Input-Field-Select'>
                        <option>{task?.businessunit}</option>
                    </select>
                </div>

                {/*==================7. Who are the primary end users of this initiative or application? *=================*/}
                <div className='Form-Row w-full'>
                    <label className='font-medium'> 7. Who are the primary end users of this initiative or application? <span className='text-[#C4314B]'>*</span> </label>
                    <select disabled className='Input-Field-Select'>
                        <option>{task?.primaryusers}</option>
                    </select>
                </div>

                {/*==================8. Which region(s) does this relate to? *=================*/}
                <div className='Form-Row w-full'>
                    <label className='font-medium'> 11. Which region(s) does this relate to? <span className='text-[#C4314B]'>*</span> </label>
                    <select disabled className='Input-Field-Select' style={{ height: '100px' }} value={task?.region} multiple>
                        <option hidden value=''>Select all that apply</option>
                        <option value='Australia'> Australia </option>
                        <option value='America'> America </option>
                        <option value='United Kingdom'> United Kingdom </option>
                        <option value='Italy'> Italy </option>
                        <option value='China'> China </option>
                        <option value='Malaysia'> Malaysia </option>
                        <option value='Japan'> Japan </option>
                        <option value='Singapore'> Singapore </option>
                    </select>
                </div>

                {/*==================9. Who is the Business Sponsor of this initiative? *=================*/}
                <div className='Form-Row w-full'>
                    <label className='font-medium'> 9. Who is the Business Sponsor of this initiative? <span className='text-[#C4314B]'>*</span> </label>
                    <input
                        disabled
                        className='Input-Field-Text w-full md:w-[450px]'
                        value={task?.businesssponsor?.email}
                    ></input>
                </div>

                {/*==================10. Who is your Line Manager? *=================*/}
                <div className='Form-Row w-full'>
                    <label className='font-medium'> 10. Who is your Line Manager? <span className='text-[#C4314B]'>*</span> </label>
                    <input
                        disabled
                        className='Input-Field-Text w-full md:w-[450px]'
                        value={task?.linemanager?.email}
                    ></input>
                </div>

                {/*==================11. Who will be the Finance Approver of this request? *=================*/}
                <div className='Form-Row w-full'>
                    <label className='font-medium'> 11. Who will be the Finance Approver of this request? <span className='text-[#C4314B]'>*</span> </label>
                    <p className='italic font-light'>Who will approve the cost onto your budget?</p>
                    <input
                        disabled
                        className='Input-Field-Text w-full md:w-[450px]'
                        value={task?.financemanager?.email}
                    ></input>
                </div>

                {/*==================12. What is the estimated cost of this request? *=================*/}
                <div className='Form-Row w-full'>
                    <label className='font-medium'> 12. What is the estimated cost of this request? <span className='text-[#C4314B]'>*</span> </label>
                    <p className='italic font-light'>Please enter your best guess or estimate in AUD. This value can be updated later.</p>
                    <input
                        disabled
                        className='Input-Field-Text  md:w-[450px]'
                        type='number'
                        value={task?.estimatedcost}
                    ></input>
                </div>

                {/*==================13. Do you have budget for this request? *=================*/}
                <div className='Form-Row w-full'>
                    <label className='font-medium'> 13. Do you have budget for this request? <span className='text-[#C4314B]'>*</span> </label>
                    <p className='italic font-light'>Do you have agreed budget available for this in your operating plan?</p>
                    <select disabled className='Input-Field-Select'>
                        <option>{task?.budgetavailable}</option>
                    </select>
                </div>

                {/*==================14. What is the cost code for this request? =================*/}
                <div className='Form-Row w-full'>
                    <label className='font-medium'> 14. What is the cost code for this request?</label>
                    <p className='italic font-light'>Please enter the cost code for any recharges. You do not have to enter it now, but it may help to speed up the completion of your request.</p>

                    {/* Project Code */}
                    <input 
                        disabled
                        className='Input-Field-Text  md:w-[450px]'
                        placeholder='Project Code'
                        type='text'
                        value={task?.projectcode}
                    ></input>

                    {/* Project Name */}
                    <input 
                        disabled
                        className='Input-Field-Text  md:w-[450px]'
                        placeholder='Project Name'
                        type='text'
                        value={task?.projectcodename}
                        hidden={task?.projectcodename === '' || task?.projectcodename === undefined}
                    ></input>

                    {/* Task Number */}
                    <input 
                        disabled
                        className='Input-Field-Text  md:w-[450px]'
                        placeholder='Task Number'
                        type='text'
                        value={task?.tasknumber}
                    ></input>

                    {/* Expenditure Type */}
                    <input 
                        disabled
                        className='Input-Field-Text  md:w-[450px]'
                        placeholder='ICT Costs'
                        type='text'
                        value={task?.expendituretype}
                    ></input>

                </div>

                {/*==================15. Is there anything else important we should know? =================*/}
                <div className='Form-Row w-full'>
                    <label className='font-medium'> 15. Is there anything else important we should know?</label>
                    <p className='italic font-light'>e.g. Are there any time constraints or compliance/security issues?</p>
                    <textarea
                        disabled
                        className='Input-Field-TextArea'
                        placeholder='Leave blank if unknown or not applicable'
                        value={task?.otherinformation}
                    ></textarea >
                </div>

            </form>
        </div>
    )
}